import { render, staticRenderFns } from "./ReportesSubTab.vue?vue&type=template&id=45c1e290&"
import script from "./ReportesSubTab.vue?vue&type=script&lang=js&"
export * from "./ReportesSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports